import { Badge, Card, Icon } from '@onepos/ui';
import type { TenantDetail } from '../../lib/types';

export function RolesTab({ data }: { data: TenantDetail }) {
  return (
    <Card title="Rollar" actions={<span className="cn-muted">Huquqlarni ega o‘z panelida sozlaydi</span>}>
      <table className="cn-table">
        <thead>
          <tr>
            <th>Rol</th>
            <th className="cn-num">Xodimlar</th>
            <th className="cn-num">Huquqlar</th>
          </tr>
        </thead>
        <tbody>
          {data.roles.map((r) => (
            <tr key={r.id}>
              <td data-label="Rol">
                <span className="cn-table__name">
                  {r.name}{' '}
                  {r.locked && (
                    <Badge tone="info">
                      <Icon name="lock" /> barcha huquqlar
                    </Badge>
                  )}
                </span>
              </td>
              <td data-label="Xodimlar" className="cn-num op-num">
                {r.staff}
              </td>
              <td data-label="Huquqlar" className="cn-num op-num">
                {r.locked ? 'hammasi' : r.permissions}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}
